import { submitMerge } from '@otto-ec/tracking-bct';

export type CustomerReviewAdvice = 'double_review' | 'not_verified' | 'currently_not_possible';

export interface TrackAddToPageImpressionParams {
    variationId: string;
    source: string;
    productFit?: boolean;
    productQuality?: boolean;
    productDesign?: boolean;
    assembly?: boolean;
    comfort?: boolean;
    valueForMoney?: boolean;
    customerReviewAdvice: CustomerReviewAdvice | undefined;
    reviewServiceReview?: string;
}
export const trackAddToPageImpression = ({
    variationId,
    source,
    productFit,
    productQuality,
    productDesign,
    assembly,
    comfort,
    valueForMoney,
    customerReviewAdvice,
    reviewServiceReview,
}: TrackAddToPageImpressionParams) => {
    submitMerge({
        ot_PageCluster: ['Kundenbewertungsformular'],
        product_VariationId: [variationId],
        review_Source: [source],
        ...(productFit !== undefined ? { review_ProductFit: [productFit ? 'true' : 'false'] } : {}),
        ...(productQuality !== undefined ? { review_ProductQuality: [productQuality ? 'true' : 'false'] } : {}),
        ...(productDesign !== undefined ? { review_ProductDesign: [productDesign ? 'true' : 'false'] } : {}),
        ...(assembly !== undefined ? { review_Assembly: [assembly ? 'true' : 'false'] } : {}),
        ...(comfort !== undefined ? { review_Comfort: [comfort ? 'true' : 'false'] } : {}),
        ...(valueForMoney !== undefined ? { review_ValueForMoney: [valueForMoney ? 'true' : 'false'] } : {}),
        ...(customerReviewAdvice ? { review_CustomerReviewAdvice: [customerReviewAdvice] } : {}),
        ...(reviewServiceReview ? { review_ServiceReview: [reviewServiceReview] } : {}),
    });
};
